import { IxLookupService, IxNgBusyFormService } from 'ix-ng-components';
import { IxKeycloakHttp, IxNgHttpService } from 'ix-ng-http';
import { IxNgCacheService, IxNgRoutingService } from 'ix-ng-routing';
import { IxNgErrorHandlingService, IxNgFormsStaticUtils } from 'ix-ng-forms';
import { inject, Injectable } from '@angular/core';
import { ObcinaLookupDTO, ObcinaLookupFilterDTO } from './obcina-lookup.model';

@Injectable()
export class ObcinaLookupService extends IxLookupService<
  number,
  undefined,
  ObcinaLookupDTO,
  ObcinaLookupFilterDTO
> {
  constructor() {
    const ixKeycloakHttp = inject(IxKeycloakHttp);
    const ixNgRoutingService = inject(IxNgRoutingService);
    const ixNgErrorHandlingService = inject(IxNgErrorHandlingService);
    const ixNgHttpService = inject(IxNgHttpService);
    const ixNgBusyFormService = inject(IxNgBusyFormService);
    const ixNgCacheService = inject(IxNgCacheService);

    super(
      ixKeycloakHttp,
      ixNgRoutingService,
      ixNgErrorHandlingService,
      ixNgHttpService,
      ixNgBusyFormService,
      ixNgCacheService,
      'obcinaLookupDTO[]',
      '/lookup/obcinaLookup',
    );
    this.predpomnenje = false;
  }

  filterById(row: ObcinaLookupDTO, idSeznam: number[]): boolean {
    return (
      row.siObcinaId !== null && row.siObcinaId !== undefined && idSeznam?.includes(row.siObcinaId)
    );
  }

  searchFunction(row: ObcinaLookupDTO, searchValue: string): boolean {
    return (
      // Function defines on which fields you search
      IxNgFormsStaticUtils.searchFunction(searchValue, row.naziv)
    );
  }

  getReadUrl(): string {
    return `readSiObcinaLookup`;
  }

  getFilterType(): ObcinaLookupFilterDTO {
    return new ObcinaLookupFilterDTO();
  }

  /**
   * Function for filtering results after reading results of cached lookup.
   * @param row
   * @param filter
   */
  override customFilter(row: ObcinaLookupDTO, filter: ObcinaLookupFilterDTO): boolean {
    if (filter.searchValue) {
      if (!row.naziv?.toUpperCase()?.includes(filter.searchValue.toUpperCase())) return false;
    }
    if (filter.prikaziAktivne === true) {
      if (row.aktiven !== true) return false;
    }
    return true;
  }
}
